import '../assets/css/initialPage.css'
import { useEffect, useRef, useState } from 'react'
// import ReactPlayer from "react-player";
import ReactPlayer from 'react-player/lazy'
import initialVideo from "../assets/videos/initialVideo.mp4";
import logoBabitaWShdw from '../assets/imgs/Initial/logoBabitaWShdw.png'
import { useNavigate } from 'react-router-dom';
export default function InitialPage({ativaResp}){

    const [isLoaded, setIsLoaded] = useState(false);
    const playerRef = useRef(null);
    const navigate = useNavigate()

    const [showBannerText, setShowBannerText] = useState(false);
    const [scaleLogo, setscaleLogo] = useState(false);


    const actualYear = new Date().getFullYear();
  
    useEffect( ()=>{
        const animateLogo = async (setShowBannerText, setScaleLogo) => {
            document.getElementsByTagName('body')[0].className = "initialPageBdy";
    
            await new Promise(resolve => setTimeout(resolve, 1000));
            setScaleLogo(true);
    
            await new Promise(resolve => setTimeout(resolve, 2500));
            setShowBannerText(true);
        };
        animateLogo(setShowBannerText, setscaleLogo)
    },[])

    const handleProgress = (state) => {
        console.log('Carregamento:', state.loaded); // Exibe o progresso
        if (state.loaded >= 0.50 && !isLoaded) {
            playerRef.current.seekTo(0); // Reinicia o vídeo
            setIsLoaded(true); // Marca o vídeo como carregado
        }
    };
    
    return <>
        <div className={`containerPrincipal initialPage`} >

        {isLoaded && (<div className="containerLogoBabita">
                <div className="actualYear">{actualYear}</div>
                <img src={logoBabitaWShdw} alt="Logo Babita" className="logoBabita" />
            </div>)}

            {!isLoaded && (
            <div className='bannerInitial'> 
            
                <img src={logoBabitaWShdw} alt="Logo Babita"
                    style={{scale: scaleLogo ? '1' : '0'}}
                 className={`logoBabitanoLoad ${showBannerText ? "showBannerText" : ""}`} />

            {showBannerText ? <div className={`textSobre ${showBannerText ? "showBannerText" : ""}`}
                style={{opacity: showBannerText ? "1" : "0"}}>Somos de Belo Horizonte e exclusivos para Revendedores em moda feminina, Lojistas 
                    e Autônomos de todo Brasil. Estamos há mais de 40 anos no mercado trazendo produtos de
                     qualidade para nossas parceiras.</div> : <></>}
            
            </div>
        )}

            <div className="containerBtnExplorar">
                <div className={`elipse ${isLoaded ? "load" : "animated"}`}></div>
                <div className="btnExplorar" onClick={()=> {
                    console.log("CLICK")
                    if(isLoaded){
                        navigate('/Inicial')
                    }
                }}>{isLoaded ? "Explorar" : "Aguarde"}</div>
            </div>

        {/* Vídeo */}
        <ReactPlayer
            ref={playerRef}
            url={initialVideo}
            playing={true} // Só inicia após 50% de carregamento
            loop
            muted
            width="100%"
            height="100%"
            playsinline 
            webkitPlaysinline
            onProgress={(onProgressvar) => handleProgress(onProgressvar)} 
            preload="metadata"
            style={{
            position: "absolute",
            top: 0,
            left: 0,
            objectFit: "cover",
            zIndex: 1,
            opacity: isLoaded ? 1 : 0
            }}
        />

        </div>
    </>
}